import { atom, type PrimitiveAtom } from "jotai";
import type { VehicleSessionSnapshot } from "../../interface/auth_types";

export const remoteClientVehicleSessionSnapshotAtom =
  atom<VehicleSessionSnapshot | null>(
    null,
  ) as PrimitiveAtom<VehicleSessionSnapshot | null>;
